// Add your own custom JS here.
// Single product page with variants by August Elements 08/29/24
// Not available variant on single product page by August Elements 09/11/24 (Comment out after decide to hide unavaialble variants)
/* function variantUnavailable() {
  colorSwatches = document.querySelectorAll('loess-variant-radios input[type=radio].disabled');
  console.log("Selector: " + colorSwatches);
  colorSwatches.forEach(colorSwatch => {
    colorSwatch.nextElementSibling.addEventListener('mouseenter', e => { e.stopPropagation(); e.preventDefault(); }, true);
    colorSwatch.nextElementSibling.addEventListener('click', e => { e.stopPropagation(); e.preventDefault(); }, true);
  });
} */
if(window.location.pathname.includes('/products') && document.querySelector('loess-variant-picker')){
  document.querySelector('loess-variant-picker').addEventListener('change', function () {
    setTimeout(()=>{
    // Change title from variants selected by August Elements 08/29/24
      const productTitle = document.querySelector('h1.js-product-title');
      const checkedVariant = document.querySelectorAll('loess-variant-radios input:checked');
      let checkedValue = Object.values(checkedVariant).map(el => el.value).join(' ');
      const productTitleDash = productTitle.innerText.lastIndexOf(' - ');
      const productTitleParent = productTitle.innerText.substring(0, productTitleDash);
      const productTitleText = productTitleParent + ' - ' + checkedValue;
      productTitle.innerHTML = productTitleText;
    // Group media by variants selected by August Elements 08/30/24
      let variantValues = Object.values(checkedVariant).map(el => el.value);
      var regex = /\d/;
      var containsNumbers = regex.test(variantValues[0]);
      if (containsNumbers) { // Gets string without numbers, so switch to strings and clean size value
        var stringValue = 1;
        firstValue = variantValues[0].replace(/[^A-Z0-9.]+/ig, "");
        secondValue = variantValues[1].replace(/[]/, "");
      } else {
        var stringValue = 0;
        firstValue = variantValues[0].replace(/[]/, "");
        secondValue = variantValues[1].replace(/[^A-Z0-9.]+/ig, "");
      };
      // let variantValue=Object.values(checkedVariant).map(el => el.value)[stringValue]; // Only gets color (second value), so remove to allow for size and color value
      let variantValue = [firstValue,secondValue].join(' ');
      const mediaGallery = document.querySelector('loess-product .main-product__media-gallery');
      if (mediaGallery.hasAttribute('media-grouping-enabled')) {
        mediaGallery.querySelectorAll('[data-media-group]').forEach(el => el.classList.add('hide-media'));
        mediaGallery.querySelectorAll('[data-media-group="'+ variantValue +'"]').forEach(el => el.classList.remove('hide-media'));
      }
    // Variant description for single variant by August Elements 09/09/24
      const collapsibleTab = document.querySelector('.main-product__block-collapsible-tab');
      const variantDetailsText = document.querySelector('#variant-details');
      const allVariantDescriptions = JSON.parse(document.querySelector('#variant-metafield-data').textContent);
      if (variantDetailsText != null) {
        const currentVariantId = document.querySelector('loess-variant-picker').currentVariant.id;
        if (allVariantDescriptions[currentVariantId] === "") {
          collapsibleTab.classList.add('hide-block');
        } else {
          collapsibleTab.classList.remove('hide-block');          
          variantDetailsText.innerHTML = allVariantDescriptions[currentVariantId];          
        }
      };
//    variantUnavailable() // Run after event change
    },1000)
  })
//  variantUnavailable() // Run when load page
}

// Update cart drawer after add an item by August Elements 07/09/25
/* async function updateCartDrawer() {
  try {
    const response = await fetch(window.Shopify.routes.root + 'cart.js');
    const cartData = await response.json();
    const cartDrawer = document.querySelector('#CartDrawer');
    const cartContent = document.querySelector('#CartDrawer .drawer__content');
console.log("Update Cart Drawer");
    if (cartDrawer && cartContent) {
//      cartContent.innerHTML = ''; // Clear existing content
      cartData.items.forEach(item => {
          const cartItem = document.createElement('div');
          cartItem.classList.add('cart-item');
          cartItem.innerHTML = '<div class="cart-item__name">${item.quantity} x ${item.title}</div>';
          cartContent.appendChild(cartItem);
console.log("Drawer Exists");
      });
    }

  } catch (error) {
    console.error('Error updating cart drawer:', error);
  }
}
document.querySelector('.product-form__submit').addEventListener('click', async () => {
  // Assuming you have a function to add items to the cart
  // await renderCartItems(); // Replace with your add to cart logic
  await fetch('/cart.js', { method: 'GET' });
  // updateCartDrawer();
  customElements.define('loess-cart-drawer-items', CartDrawerItems);
console.log("Run to End");
}); */

/* window.addEventListener('load', function() {
  const cartDrawer = document.querySelector('#CartDrawer');
  const cartItems = document.querySelector('loess-cart-drawer-items');
  if (!cartItems.classList.contains('is-empty')) {
    setTimeout(function() {
      cartDrawer.setAttribute('open', '');
    }, 1000);
  }  
}); */
// On initial load or when value is set/changed
document.addEventListener('DOMContentLoaded', () => {
  const cartDrawer = document.querySelector('#CartDrawer');
  const cartCount = document.querySelector('.header-cart-icon__count span:first-of-type')
  const cartButton = document.querySelector('.product-form__submit');
  const cartHeaderButton = document.querySelector('#HeaderCartIcon button');
  if(cartCount != null){
    var initialValue = cartCount.innerText;
  } else {
    var initialValue = 0;    
  }
  cartButton.addEventListener('click', function() {
    const preventLocalStorageUpdate = true;
    if (!preventLocalStorageUpdate) {
      const initialValue = cartCount.innerText - 1;
    }
  });
  cartHeaderButton.addEventListener('click', function() {
    cartDrawer.classList.add('drawer-visible');
  });
});
// After a page reload
window.addEventListener('load', () => {
  const cartDrawer = document.querySelector('#CartDrawer');
  const cartItems = document.querySelector('loess-cart-drawer-items');
  const cartCount = document.querySelector('.header-cart-icon__count span:first-of-type')
  const storedValue = localStorage.getItem('persistedValue');
  if(cartCount != null){
    var newValue = cartCount.innerText;
  } else {
    var newValue = 0;    
  }
  if (newValue !== storedValue) {
    if (!cartItems.classList.contains('is-empty')) {
      cartDrawer.setAttribute('open', '');
      cartDrawer.classList.add('drawer-visible');
    }  
    localStorage.setItem('persistedValue', newValue);
  }
  const observer = new MutationObserver(function(mutationsList, observer) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
        if (!cartDrawer.hasAttribute('open')) {
          cartDrawer.classList.remove('drawer-visible');
        }
      }
    }
  });
  const config = { attributes: true }; // Observe attribute changes
  observer.observe(cartDrawer, config);
});